import { RootDispatch, RootGetState } from "../types";
import history from "../../history";
import flash from "../flash/actions";
import { getPatientList, getLocations } from "../dashboard/actions";
import { postForm } from "../../utils/fetch";

export type Action =
  | { type: "uploadPatients/uploadPatients-started" }
  | { type: "uploadPatients/uploadPatients-success" }
  | {
      type: "uploadPatients/uploadPatients-failure";
      uploadRowErrors: { [k: string]: string } | null;
    };

export const uploadPatients = (file: FormData) => async (
  dispatch: RootDispatch,
  getState: RootGetState
) => {
  dispatch({
    type: "uploadPatients/uploadPatients-started"
  });

  const url = "/api/organization/" + getState().orgs.currentOrganization?.id + "/patients/upload/";

  const resp = await postForm(url, file);

  if (resp.error) {
    dispatch({
      type: "uploadPatients/uploadPatients-failure",
      error: resp.error.message,
      uploadRowErrors: resp.error.fieldErrors
    });
    dispatch(flash("Patient file upload error: " + resp.error.message, "error"));
  } else if (resp.data) {
    dispatch({
      type: "uploadPatients/uploadPatients-success"
    });
    dispatch(flash("Patient file has been successfully uploaded."));
    dispatch(getPatientList());
    dispatch(getLocations());
    history.push("/dashboard/");
  }
};
